/**
 * What poll-card.vue needs from the app it is shown in. The card is shared by LIQUIDO and Polly, so it knows
 * no backend itself: each app provides one object under POLL_CARD_API, once, in its main.js.
 *
 *   reloadPoll(id)                   -> Promise of the poll, fetched again at its end (the backend returns it FINISHED)
 *   currentUserId()                  -> the id of the logged-in user, or undefined. Their own proposals get the pencil
 *                                       and cannot be liked.
 *   likeProposal(pollId, proposalId) -> like a proposal. Without it nothing on the card can be liked.
 *
 * LIQUIDO's is src/liquido/services/liquido-poll-card-api.js. A page may still pass its own `reloadPoll` prop to the
 * card, which wins over the provided one - pollys-list.vue does, so a polly id never reaches the team API.
 */
export const POLL_CARD_API = Symbol("pollCardApi")
